/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'reactstrap';
import { getAuthToken, isAuthenticated } from '../../../auth/tokenvalidation';
//import img3 from "../../../assets/images/companies/img-3.png";
import axios from 'axios';
import { api, web } from '../../../config';
import notify, { MESSAGES } from '../../../utils/notify';
import { Alert, UncontrolledAlert } from 'reactstrap';
import ActionButton from '../../../Components/Common/ActionButton';
import { FileField, FormGrid, SelectField } from '../../../Components/Form';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const FileUploadSection = ({
  ids,
  fetchDocumentUpload,
  formFileUpload,
  setFormFileUpload,
  uploadDocument,
  readonly,
}) => {
  const [fileCategory, setFileCategory] = useState({ items: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  const token = getAuthToken();

  useEffect(() => {
    fetchFileCategory();
  }, []);

  const fetchFileCategory = async () => {
    try {
      const response = await fetch(
        `${api.API_URL}/document-upload/getall-master-hps-document`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.documentName,
      }));
      setFileCategory({ items });
    } catch (error) {
      console.error('Error:', error);
    } finally {
    }
  };

  const handleSelectChange = (selected, field) => {
    const value = selected ?? '';
    const newData = {
      ...formFileUpload,
      [field]: value,
    };
    setFormFileUpload(newData);
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0]; // Ambil file pertama
    const newData = {
      ...formFileUpload,
      [field]: file, // Simpan file ke state
    };
    setFormFileUpload(newData);
  };

  const handleAddFileUpload = async e => {
    try {
      console.log(formFileUpload);
      setIsLoading(true);
      const response = await axios.post(
        `${api.API_URL}/hps/upload-hps`,
        formFileUpload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      notify.success(MESSAGES.uploaded);
    } catch (error) {
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        fetchDocumentUpload();
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        setFormFileUpload(prev => ({
          ...prev,
          fileAttachment: null,
          DocumentUploadId: null,
        }));
      }, 500);
    }

    // finally {
    //   setIsLoading(false);
    //   fetchDocumentUpload();
    // }
  };

  const [isBookmarkClick, setIsBookmarkClick] = useState(false);
  return (
    <React.Fragment>
      <Col>
        <FormGrid columns={1}>
          <SelectField
            label='File category'
            name='DocumentUploadId'
            options={fileCategory.items}
            value={formFileUpload.DocumentUploadId}
            onChange={value => handleSelectChange(value, 'DocumentUploadId')}
          />
          <FileField
            label='File'
            name='fileAttachment'
            inputRef={fileInputRef}
            mode={isLoading ? 'disabled' : 'editable'}
            onChange={e => handleFileChange(e, 'fileAttachment')}
          />
        </FormGrid>

        <div className='text-end mt-3'>
          {readonly && (
            <ActionButton
              variant='primary'
              size='sm'
              icon='ri-upload-cloud-2-line'
              onClick={() => handleAddFileUpload()}
              loading={isLoading}
            >
              {isLoading ? 'Uploading...' : 'Upload File'}
            </ActionButton>
          )}
        </div>
      </Col>
    </React.Fragment>
  );
};

export default FileUploadSection;
